import AxiosConfig from '../utils/AxiosConfig';

const buildParams = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return query.toString();
};

class DebugLogsService {
  async getErrors(params) {
    const response = await AxiosConfig.get(`/debug/errors?${buildParams(params)}`);
    return response.data.data;
  }

  async updateErrorResolved(tenantId, id, resolved) {
    const response = await AxiosConfig.patch(
      `/debug/errors/${id}/resolved?${buildParams({ tenantId })}`,
      { resolved }
    );
    return response.data.data;
  }

  async resolveErrors(tenantId, ids = null) {
    const response = await AxiosConfig.post(
      `/debug/errors/resolve?${buildParams({ tenantId })}`,
      { ids }
    );
    return response.data.data;
  }

  async deleteErrors(tenantId, ids = null) {
    const response = await AxiosConfig.post(
      `/debug/errors/delete?${buildParams({ tenantId })}`,
      { ids }
    );
    return response.data.data;
  }

  async exportErrors(params) {
    return this.downloadCsv('/debug/errors/export', params, 'error-logs.csv');
  }

  async getAudit(params) {
    const response = await AxiosConfig.get(`/debug/audit?${buildParams(params)}`);
    return response.data.data;
  }

  async exportAudit(params) {
    return this.downloadCsv('/debug/audit/export', params, 'audit-logs.csv');
  }

  async getCheckout(params) {
    const response = await AxiosConfig.get(`/debug/checkout?${buildParams(params)}`);
    return response.data.data;
  }

  async getCheckoutGroups(params) {
    const response = await AxiosConfig.get(`/debug/checkout/groups?${buildParams(params)}`);
    return response.data.data;
  }

  async getCheckoutGroupDetails(params) {
    const response = await AxiosConfig.get(`/debug/checkout/group?${buildParams(params)}`);
    return response.data.data;
  }

  async exportCheckout(params) {
    return this.downloadCsv('/debug/checkout/export', params, 'checkout-logs.csv');
  }

  async downloadCsv(path, params, filename) {
    const response = await AxiosConfig.get(`${path}?${buildParams(params)}`, {
      responseType: 'blob'
    });
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export default new DebugLogsService();
